import { RootState } from "../StoreHooks";

export const getScreenName = (state: RootState) => {
  const { screenName } = state.screenName || {};
  return screenName;
};
